<template>
    <div>
        <div class="flex justify-between">
            <h4>Restarts</h4>

        </div>
        <vue-apex-charts v-if="chartOptions" type="bar" height="180" :options="chartOptions" :series="chartData"/>
    </div>
</template>
<script>

    import VueApexCharts from 'vue-apexcharts'

    export default {
        props: {
            workerChannelId: {
                type: Number,
                required: true
            }
        },
        components: {
            VueApexCharts
        },
        data() {
            return {
                chartData: [],
                categories: [],

                chartOptions: null
            }
        },
        methods: {
            loadData() {
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.workerChannelId + '/metrics/restart')
                loadPromise.then(function(response) {
                    thisIns.chartData = [{
                        name: 'Restarts',
                        data: response.data.data
                    }]
                    thisIns.categories = response.data.categories
                    thisIns.$nextTick(function() {
                        thisIns.updateChartOptions()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            },
            updateChartOptions() {
                this.chartOptions = {
                    plotOptions: {
                        bar: {
                            colors: {
                                ranges: [{
                                    from: 10,
                                    to: 300,
                                    color: '#F15B46'
                                }, {
                                    from: 6,
                                    to: 10,
                                    color: '#FEB019'
                                }]
                            },
                            columnWidth: '90%'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    yaxis: {
                        title: {
                            text: 'Restarts'
                        },
                        labels: {
                            formatter: function(y) {
                                return y.toFixed(0)
                            }
                        }
                    },
                    xaxis: {
                        categories: this.categories,
                        labels: {
                            show: false
                        }
                    }
                }
            }
        },
        mounted() {
            this.loadData()
        }

    }

</script>
